import './maintenancepage.css';
import AnimatedLogo from './AnimatedLogo';

const RefreshIcon = () => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width="20" 
        height="20" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
    >
        <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
        <path d="M3 3v5h5"/>
        <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"/>
        <path d="M16 16h5v5"/>
    </svg>
);

export default function MaintenancePage() {
    const handleRefresh = () => {
        window.location.reload();
    };

    return (
        <div className="maintenance-page">
            <div className="maintenance-content">
                <div className="maintenance-icon">
                    <AnimatedLogo size="large" />
                </div>
                <h1 className="maintenance-title">ТЕХНИЧЕСКИЕ РАБОТЫ</h1>
                <p className="maintenance-message">
                    Мы работаем над улучшением сайта, возвращайтесь через минуту
                </p>
                <button 
                    className="maintenance-refresh-btn"
                    onClick={handleRefresh}
                >
                    <RefreshIcon />
                    Обновить страницу
                </button>
            </div>
        </div>
    );
}
